import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

// import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import CurrencyFormat from 'react-currency-format';

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';


import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

const Cards = () => {
    const navigate = useNavigate();

    const [cards, setCards] = useState([]);
    const [usdCards, setUSDCards] = useState(0);
    const [ngnCards, setNGNCards] = useState(0);

    // const { ExportCSVButton } = CSVExport;

    useEffect(() => {
        getCards();
    }, []);


  async function getCards() {
      const token = localStorage.getItem("token");
      try {
        const res = await api.get("/admin/all-cards", {
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        });
      if (res.data.success) {
        // setCards(res.data.cards.map(
        //     (card, index)=>{return(
        //         <tr key={card.account_id}>
        //             <td>{index+1}</td>
        //             <td>{card.name_on_card}</td>
        //             <th scope="row"><a href="#">{card.masked_pan}</a></th>
        //             <td>{card.currency}</td>
        //             <td>{card.amount}</td>
        //             <td><a onClick={
        //                 ()=>navigate('/customer', {
        //                     state: {
        //                       customer: card,
        //                     }
        //                   })
        //             } href="" className="text-primary">View Card</a></td>
        //         </tr>
        //     )
        // }));
        setCards(res.data.cards);
        setUSDCards(res.data.cards.filter(card => {
            if (card.currency == "USD") {
              return true;
            }
          
            return false;
          }).length);
        setNGNCards(res.data.cards.filter(card => {
            if (card.currency == "NGN") {
            return true;
            }
        
            return false;
        }).length);
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  const columns = [
    // {
    //   dataField: "id",
    //   text: "SN",
    //   sort: true
    // },
    {
      dataField: "name_on_card",
      text: "Customer Name",
    //   filter: textFilter(),
      sort: true
    },
    {
      dataField: "masked_pan",
      text: "Card Details",
    //   filter: textFilter()
    },
    {
      dataField: "currency",
      text: "Card Currency"
    },
    {
      dataField: "amount",
      text: "Card Balance",
      formatter:(cellContent, row) => (
        <span><CurrencyFormat value={row.amount} displayType={'text'} thousandSeparator={true} renderText={value => <div>{value}</div>} /></span>
      ),
      sort: true
    },
    {
      dataField: "amount",
      text: "Action",
        formatter: (cellContent, row) => (
          <a onClick={
            ()=>navigate('/card', {
                state: {
                    card: row,
                }
              })
        } href="" className="text-primary">View Card</a>
        )
    }
  ];

  return (
<div>
        <Header/>
        <Sidebar/>
        <main id="main" className="main">
          <div className="pagetitle">
            <h1>Cards</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active">Cards</li>
              </ol>
            </nav>
          </div>{/* End Page Title */}
          <section className="section dashboard">
            <div className="row">
              {/* Left side columns */}
              <div className="col-lg-12">
                <div className="row">
                  {/* Users Card */}
                  <div className="col-xxl-4 col-md-6">
                    <div className="card info-card sales-card">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">All Cards</h5>
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-credit-card-fill" />
                          </div>
                          <div className="ps-3">
                            <h6>{cards.length}</h6>
                             <span className="text-muted small pt-2 ps-1">Virtual Cards</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{/* End Users Card */}
                  {/* Approved Card */}
                  <div className="col-xxl-4 col-md-6">
                    <div className="card info-card revenue-card">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">USD Cards</h5>
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-credit-card-fill" />
                          </div>
                          <div className="ps-3">
                            <h6>{usdCards}</h6>
                            <span className="text-muted small pt-2 ps-1">US Dollar Cards</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{/* End Approved Card */}
                  {/* Cards Card */}
                  <div className="col-xxl-4 col-xl-12">
                    <div className="card info-card cards-card">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">NGN Cards</h5>
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-credit-card-fill" />
                          </div>
                          <div className="ps-3">
                            <h6>{ngnCards}</h6>
                            <span className="text-muted small pt-2 ps-1">Nigerian Naira Cards</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{/* End Cards Card */}
                  

                  {/* All Cards */}
                  <div className="col-12">
                    <div className="card recent-sales overflow-auto">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">All Cards <span>| Today</span></h5>
                        <BootstrapTable
                            bootstrap4
                            keyField="id"
                            data={cards}
                            columns={columns}
                            bordered={ false }
                            pagination={paginationFactory({ sizePerPage: 20 })}
                        />
                        {/* <ToolkitProvider
                            keyField="id"
                            data={ products }
                            columns={ columns }
                            exportCSV
                            >
                            {
                                props => (
                                <div>
                                    <ExportCSVButton { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                                    <hr />
                                    <BootstrapTable { ...props.baseProps } />
                                </div>
                                )
                            }
                        </ToolkitProvider> */}
                      </div>
                    </div>
                  </div>{/* End All Cards */}

                </div>
              </div>{/* End Left side columns */}
            </div>
          </section>
        </main>{/* End #main */}
       <Footer/>
        <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
      </div>
  );
};
export default Cards;